import React from 'react'
import { Image, useTheme, ImageProps } from '@gousto-internal/citrus-react'

interface ResponsiveImageProps extends Omit<ImageProps, 'src'> {
  mobileWebp: string
  desktopWebp: string
  fallbackSrc: string
  alt: string
  borderRadius?: string | number
}

export function ResponsiveImage({
  mobileWebp,
  desktopWebp,
  fallbackSrc,
  alt,
  borderRadius = '8px',
  ...imageProps
}: ResponsiveImageProps) {
  const { theme } = useTheme()
  return (
    <picture>
      <source
        srcSet={mobileWebp}
        media={`(max-width: ${theme.tokens.breakpoints[1]})`}
        type="image/webp"
      />
      <source
        srcSet={desktopWebp}
        media={`(min-width: ${theme.tokens.breakpoints[1]})`}
        type="image/webp"
      />
      <Image
        {...imageProps}
        width={imageProps.width ?? '100%'}
        src={fallbackSrc}
        alt={alt}
        style={{ borderRadius, ...imageProps.style }}
      />
    </picture>
  )
}
